import React, { useState } from 'react';
import { BookOpen, CheckCircle, ChevronDown, ChevronUp, Award, FileText, Users, Target, Shield } from 'lucide-react';
export const AGPOKnowledgeHub = () => {
  const [openStep, setOpenStep] = useState<number | null>(0);
  const steps = [{
    title: 'What is AGPO?',
    icon: <BookOpen size={24} className="text-primary-600" data-id="element-46" />,
    content: <div className="space-y-4" data-id="element-47">
          <p className="text-gray-700" data-id="element-48">
            The Access to Government Procurement Opportunities (AGPO) is a
            program designed to ensure that Youth, Women, and Persons with
            Disabilities (PWDs) access at least{' '}
            <strong data-id="element-49">30% of all government procurement opportunities</strong>.
          </p>
          <div className="bg-primary-50 rounded-lg p-4" data-id="element-50">
            <h4 className="font-semibold text-primary-900 mb-2" data-id="element-51">
              Who Qualifies?
            </h4>
            <ul className="space-y-2 text-sm text-gray-700" data-id="element-52">
              <li className="flex items-start gap-2" data-id="element-53">
                <CheckCircle size={16} className="text-primary-600 flex-shrink-0 mt-0.5" data-id="element-54" />
                <span data-id="element-55">
                  <strong data-id="element-56">Youth:</strong> Kenyan citizens aged 18-35 years
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-57">
                <CheckCircle size={16} className="text-primary-600 flex-shrink-0 mt-0.5" data-id="element-58" />
                <span data-id="element-59">
                  <strong data-id="element-60">Women:</strong> Female Kenyan citizens of any age
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-61">
                <CheckCircle size={16} className="text-primary-600 flex-shrink-0 mt-0.5" data-id="element-62" />
                <span data-id="element-63">
                  <strong data-id="element-64">PWDs:</strong> Persons with disabilities certified by
                  NCPWD
                </span>
              </li>
            </ul>
          </div>
        </div>
  }, {
    title: 'Eligibility Requirements',
    icon: <Users size={24} className="text-primary-600" data-id="element-65" />,
    content: <div className="space-y-4" data-id="element-66">
          <p className="text-gray-700 mb-4" data-id="element-67">
            To register for AGPO, you must meet these requirements:
          </p>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-68">
            <div className="bg-white border-2 border-primary-200 rounded-lg p-4" data-id="element-69">
              <CheckCircle size={20} className="text-primary-600 mb-2" data-id="element-70" />
              <h4 className="font-semibold text-gray-900 mb-1" data-id="element-71">
                Valid National ID
              </h4>
              <p className="text-sm text-gray-600" data-id="element-72">Kenyan citizenship proof</p>
            </div>
            <div className="bg-white border-2 border-primary-200 rounded-lg p-4" data-id="element-73">
              <CheckCircle size={20} className="text-primary-600 mb-2" data-id="element-74" />
              <h4 className="font-semibold text-gray-900 mb-1" data-id="element-75">
                Tax Compliance Certificate
              </h4>
              <p className="text-sm text-gray-600" data-id="element-76">From KRA (iTax portal)</p>
            </div>
            <div className="bg-white border-2 border-primary-200 rounded-lg p-4" data-id="element-77">
              <CheckCircle size={20} className="text-primary-600 mb-2" data-id="element-78" />
              <h4 className="font-semibold text-gray-900 mb-1" data-id="element-79">
                Business Registration
              </h4>
              <p className="text-sm text-gray-600" data-id="element-80">
                Certificate of Incorporation
              </p>
            </div>
            <div className="bg-white border-2 border-primary-200 rounded-lg p-4" data-id="element-81">
              <CheckCircle size={20} className="text-primary-600 mb-2" data-id="element-82" />
              <h4 className="font-semibold text-gray-900 mb-1" data-id="element-83">
                70% Ownership Rule
              </h4>
              <p className="text-sm text-gray-600" data-id="element-84">
                Youth/Women/PWDs must own 70%+
              </p>
            </div>
          </div>
        </div>
  }, {
    title: 'The AGPO Registration Process',
    icon: <Target size={24} className="text-primary-600" data-id="element-85" />,
    content: <div className="space-y-4" data-id="element-86">
          <div className="space-y-4" data-id="element-87">
            <div className="flex gap-4" data-id="element-88">
              <div className="flex-shrink-0 w-10 h-10 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold" data-id="element-89">
                1
              </div>
              <div data-id="element-90">
                <h4 className="font-semibold text-gray-900 mb-1" data-id="element-91">
                  Register Your Business
                </h4>
                <p className="text-sm text-gray-600" data-id="element-92">
                  Visit eCitizen or Business Registration Service (BRS) to
                  register your business entity
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-93">
              <div className="flex-shrink-0 w-10 h-10 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold" data-id="element-94">
                2
              </div>
              <div data-id="element-95">
                <h4 className="font-semibold text-gray-900 mb-1" data-id="element-96">
                  Get Tax Compliance Certificate
                </h4>
                <p className="text-sm text-gray-600" data-id="element-97">
                  Apply through iTax portal (KRA). Ensure all tax obligations
                  are up to date
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-98">
              <div className="flex-shrink-0 w-10 h-10 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold" data-id="element-99">
                3
              </div>
              <div data-id="element-100">
                <h4 className="font-semibold text-gray-900 mb-1" data-id="element-101">
                  Obtain Professional Certifications
                </h4>
                <p className="text-sm text-gray-600" data-id="element-102">
                  Get relevant certifications (NCA for construction,
                  professional body memberships, etc.)
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-103">
              <div className="flex-shrink-0 w-10 h-10 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold" data-id="element-104">
                4
              </div>
              <div data-id="element-105">
                <h4 className="font-semibold text-gray-900 mb-1" data-id="element-106">
                  Register on AGPO Portal
                </h4>
                <p className="text-sm text-gray-600" data-id="element-107">
                  Visit{' '}
                  <a href="https://agpo.go.ke" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline font-semibold" data-id="element-108">
                    agpo.go.ke
                  </a>{' '}
                  and complete your registration with all required documents
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-109">
              <div className="flex-shrink-0 w-10 h-10 bg-primary-600 text-white rounded-full flex items-center justify-center font-bold" data-id="element-110">
                5
              </div>
              <div data-id="element-111">
                <h4 className="font-semibold text-gray-900 mb-1" data-id="element-112">
                  Find & Bid for Tenders
                </h4>
                <p className="text-sm text-gray-600" data-id="element-113">
                  Search for tenders on{' '}
                  <a href="https://tenders.go.ke" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline font-semibold" data-id="element-114">
                    tenders.go.ke
                  </a>{' '}
                  (PPIP portal)
                </p>
              </div>
            </div>
          </div>
        </div>
  }, {
    title: "Geldhaus's Role in Your Success",
    icon: <Award size={24} className="text-primary-600" data-id="element-115" />,
    content: <div className="space-y-4" data-id="element-116">
          <div className="bg-gradient-to-br from-primary-600 to-primary-700 text-white rounded-xl p-6" data-id="element-117">
            <h4 className="text-xl font-bold mb-4" data-id="element-118">
              How We Support Your Tendering Journey
            </h4>
            <div className="space-y-4" data-id="element-119">
              <div className="flex gap-3" data-id="element-120">
                <Shield size={24} className="flex-shrink-0" data-id="element-121" />
                <div data-id="element-122">
                  <h5 className="font-semibold mb-1" data-id="element-123">
                    Bid Bonds (1 Hour Approval)
                  </h5>
                  <p className="text-sm text-primary-100" data-id="element-124">
                    Required to submit your tender. We provide unsecured bid
                    bonds with instant approval.
                  </p>
                </div>
              </div>
              <div className="flex gap-3" data-id="element-125">
                <FileText size={24} className="flex-shrink-0" data-id="element-126" />
                <div data-id="element-127">
                  <h5 className="font-semibold mb-1" data-id="element-128">LPO Financing</h5>
                  <p className="text-sm text-primary-100" data-id="element-129">
                    Once you win the tender, we finance your LPO so you can
                    deliver without cash flow constraints.
                  </p>
                </div>
              </div>
              <div className="flex gap-3" data-id="element-130">
                <Award size={24} className="flex-shrink-0" data-id="element-131" />
                <div data-id="element-132">
                  <h5 className="font-semibold mb-1" data-id="element-133">Performance Bonds</h5>
                  <p className="text-sm text-primary-100" data-id="element-134">
                    Required after winning. We provide performance bonds with
                    reduced collateral requirements.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-135">
            <a href="#trade-finance" className="flex-1 text-center py-4 px-6 bg-primary-600 hover:bg-primary-700 text-white font-bold rounded-xl transition-all duration-300 shadow-lg" data-id="element-136">
              Explore Trade Finance
            </a>
            <a href="#apply-now" className="flex-1 text-center py-4 px-6 bg-white hover:bg-gray-50 text-primary-600 font-bold rounded-xl border-2 border-primary-600 transition-all duration-300" data-id="element-137">
              Consult on Tendering
            </a>
          </div>
        </div>
  }];
  return <section className="py-20 bg-white" data-id="element-138">
      <div className="container" data-id="element-139">
        <div className="text-center mb-16" data-id="element-140">
          <div className="inline-flex items-center gap-2 bg-primary-100 text-primary-700 px-5 py-2 rounded-full text-sm font-semibold mb-6" data-id="element-141">
            <BookOpen size={18} data-id="element-142" />
            Educational Resource
          </div>
          <h2 className="section-title" data-id="element-143">
            Mastering Kenya Government Tendering (AGPO)
          </h2>
          <p className="section-subtitle" data-id="element-144">
            Your complete guide to accessing the 30% government procurement
            opportunities reserved for Youth, Women, and PWDs
          </p>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-145">
          <div className="space-y-4" data-id="element-146">
            {steps.map((step, index) => <div key={index} className="bg-white border-2 border-gray-200 rounded-2xl overflow-hidden hover:border-primary-300 transition-all duration-300" data-id="element-147">
                <button onClick={() => setOpenStep(openStep === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors duration-200" data-id="element-148">
                  <div className="flex items-center gap-4" data-id="element-149">
                    <div className="w-12 h-12 bg-primary-50 rounded-xl flex items-center justify-center" data-id="element-150">
                      {step.icon}
                    </div>
                    <div data-id="element-151">
                      <div className="text-sm font-semibold text-primary-600 mb-1" data-id="element-152">
                        Step {index + 1}
                      </div>
                      <h3 className="text-lg font-bold text-gray-900" data-id="element-153">
                        {step.title}
                      </h3>
                    </div>
                  </div>
                  <div className="text-primary-600" data-id="element-154">
                    {openStep === index ? <ChevronUp size={24} data-id="element-155" /> : <ChevronDown size={24} data-id="element-156" />}
                  </div>
                </button>

                {openStep === index && <div className="px-6 pb-6 animate-fadeIn" data-id="element-157">
                    <div className="pl-16" data-id="element-158">{step.content}</div>
                  </div>}
              </div>)}
          </div>

          {/* Download CTA */}
          <div className="mt-12 bg-gradient-to-r from-primary-600 to-primary-700 rounded-2xl p-8 text-white text-center" data-id="element-159">
            <h3 className="text-2xl font-bold mb-4" data-id="element-160">
              Want the Complete AGPO Framework Guide?
            </h3>
            <p className="text-primary-100 mb-6 max-w-2xl mx-auto" data-id="element-161">
              Download our comprehensive PDF guide with checklists, timelines,
              and pro tips for successful government tendering
            </p>
            <button className="bg-white text-primary-600 hover:bg-primary-50 font-bold py-4 px-8 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-162">
              Download AGPO Framework Guide
            </button>
          </div>
        </div>
      </div>
    </section>;
};